module.exports = __webpack_public_path__ + "mf.svg?647123880ea3877d53947e8c33ecabe4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/mf.svg
// module id = 1491
// module chunks = 0